import type { z } from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { salaryGradeQuerySchema } from './salary-grade-query-schema';

export const salaryGradeUpdateSchema = salaryGradeQuerySchema
  .pick({ id: true, name: true })
  .extend({ status: statusMutationSchema });

export type SalaryGradeUpdateSchema = z.infer<typeof salaryGradeUpdateSchema>;

export const salaryGradeCreateSchema = salaryGradeUpdateSchema.pick({ name: true, status: true });
export type SalaryGradeCreateSchema = z.infer<typeof salaryGradeCreateSchema>;
